import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./cartItem.scss";

import defaultImage from "assets/images/imgs/empty_img.png";
const CartItem = ({
    item,
    isChecked,
    onQuantityUpdate,
    onCheckChange,
    onRemove,
    isRemoveDisabled = false,
}) => {
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(item.quantity);
    const [hasChanges, setHasChanges] = useState(false);

    // 수량 감소 핸들러
    const handleDecreaseQuantity = () => {
        if (quantity > 1) {
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            setHasChanges(true);
        }
    };

    // 수량 증가 핸들러
    const handleIncreaseQuantity = () => {
        if (quantity < item.available_stock) {
            const newQuantity = quantity + 1;
            setQuantity(newQuantity);
            setHasChanges(true);
        }
    };

    // 옵션수정 버튼 핸들러
    const handleUpdateQuantity = async () => {
        if (onQuantityUpdate) {
            try {
                await onQuantityUpdate(item.id, quantity);
                setHasChanges(false);
            } catch (err) {
                console.error("수량 변경 실패:", err);
                // 실패 시 원래 수량으로 복원
                setQuantity(item.quantity);
                setHasChanges(false);
            }
        }
    };

    // 체크박스 변경 핸들러
    const handleCheckChange = (e) => {
        if (onCheckChange) {
            onCheckChange(item.id, e.target.checked);
        }
    };

    // 가격 포맷팅
    const formatPrice = (price) => {
        return Number(price).toLocaleString("ko-KR");
    };

    // 단가 계산
    const unitPrice = Number(item.item_price);
    const totalPrice = unitPrice * quantity;

    return (
        <div className="cart-item">
            <div className="cart-item__checkbox-wrapper">
                <input
                    type="checkbox"
                    id={`cart-item-${item.id}`}
                    className="cart-item__checkbox"
                    checked={isChecked}
                    onChange={handleCheckChange}
                    aria-label={`${item.name} 선택`}
                />
                <label
                    htmlFor={`cart-item-${item.id}`}
                    className="cart-item__checkbox-label"
                />
            </div>

            <div className="cart-item__info">
                <div className="cart-item__image">
                    <div
                        className="cart-item__image-placeholder"
                        onClick={() => {
                            const detailPath =
                                item.item_type === "lesson"
                                    ? `/class/detail/${item.item_id}`
                                    : `/product/detail/${item.item_id}`;
                            navigate(detailPath);
                        }}
                    >
                        {
                            <img
                                src={
                                    item.images === null
                                        ? defaultImage
                                        : item.images.image
                                }
                                alt={item.name}
                                onError={(e) => {
                                    e.currentTarget.src = defaultImage;
                                }}
                            />
                        }
                    </div>
                </div>

                <div className="cart-item__details">
                    <div className="cart-item__header">
                        <h3 className="cart-item__name">{item.name}</h3>
                        <button
                            type="button"
                            className="cart-item__remove-btn"
                            onClick={() => onRemove(item.id)}
                            disabled={isRemoveDisabled}
                            aria-label={`${item.name} 삭제`}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15 5L5 15M5 5L15 15"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className="cart-item__price-info">
                        <span className="cart-item__unit-price">
                            {formatPrice(unitPrice)}원
                        </span>
                    </div>

                    <div className="cart-item__option-info">
                        <span className="cart-item__unit-option">
                            {item.selected_options?.length > 0
                                ? item.selected_options
                                      .map((opt) => opt.option_value)
                                      .join(" / ")
                                : item.lesson_option_display || ""}
                        </span>
                    </div>

                    <div className="cart-item__stock-status">
                        {item.in_stock === 0 && (
                            <span className="cart-item__stock-unavailable">
                                품절
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div className="cart-item__actions">
                <div className="cart-item__quantity">
                    <button
                        type="button"
                        className="cart-item__quantity-btn"
                        onClick={handleDecreaseQuantity}
                        disabled={quantity <= 1}
                        aria-label="수량 감소"
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3 8H13"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                    <span className="cart-item__quantity-value">
                        {quantity}
                    </span>
                    <button
                        type="button"
                        className="cart-item__quantity-btn"
                        onClick={handleIncreaseQuantity}
                        disabled={quantity >= item.available_stock}
                        aria-label="수량 증가"
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8 3V13M3 8H13"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                </div>

                {hasChanges ? (
                    <button
                        type="button"
                        className="cart-item__update-btn"
                        onClick={handleUpdateQuantity}
                    >
                        옵션수정
                    </button>
                ) : (
                    <div className="cart-item__total-price">
                        <span className="cart-item__total-price-value">
                            {formatPrice(totalPrice)}원
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CartItem;
